<div class="content">
  <div class="inner-content">
    <ng-content></ng-content>
  </div>
</div>
@if (showCopyright) {
  <div class="copyright">&copy; 2007 - {{ currentDate | date: 'yyyy' }} Pipelinersales Inc.</div>
}
